import React, { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import ErrorDisplay from '../../../../molecules/ErrorDisplay'
import FadeIn from '../../../../molecules/Transitions/FadeIn'
import OperationalTable from '../../../../organisms/OperationalTable'
import AdminPage from '../../shared/AdminPage'
import { useTags } from './useTags'

export const defaultColumnConfig = {
  columns: [
    { Header: 'Id', accessor: 'id', type: 'number' },
    { Header: 'Tag Name', accessor: 'tagName', type: 'string' },
    { Header: 'Description', accessor: 'description', type: 'string' },
    { Header: 'Member Type', accessor: 'memberType', type: 'string' }
  ],
  defaultSort: [{ id: 'Id', desc: false }]
}

const ClientTagsTab = () => {
  const { tagData, isLoading, error, isError } = useTags()
  const history = useHistory()

  const onClickRow = useCallback(
    (row) => {
      if (row.original) {
        history.push(`/admin/data-maintenance/tags/${row.original.id}`)
      }
    },
    [history]
  )
  const [data, setData] = React.useState([])
  const shapeData = (respData) => {
    if (!respData) return []
    return respData.listData.map((item) => {
      return {
        id: item.groupTypeId,
        tagName: item.longName,
        description: item.description,
        memberType: item.clientSpecific === 1 ? 'Client-Specific' : item.memberTypes[0].memberLevelTypeLongName
      }
    })
  }
  useMemo(() => {
    setData(shapeData(tagData))
  }, [tagData])
  return (
    <AdminPage>
      <FadeIn>
        {isError ? (
          <ErrorDisplay error={error} />
        ) : !isLoading && data.length === 0 ? (
          <ErrorDisplay soft error='No client tags found' />
        ) : (
          <OperationalTable
            variant='v2'
            mode='auto'
            itemName='Client Tags'
            data={data || []}
            onRowClick={(data) => {
              onClickRow(data)
            }}
            loading={isLoading}
            total={data?.length}
            columns={defaultColumnConfig.columns}
            defaultSort={defaultColumnConfig.defaultSort}
          />
        )}
      </FadeIn>
    </AdminPage>
  )
}

export default ClientTagsTab
